import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import ContactButtons from '../../components/ProfileSearch/ProfileDetails/ContactButtons/ContactButtons';
import { ProfileImage } from '../../components/common/ProfileImage/ProfileImage';
import { FavoriteIcon } from '../../components/common/FavoriteIcon/FavoriteIcon';
import { AvailabilityStatus } from '../../components/common/AvailabilityStatus/AvailabilityStatus';
import { RelocationSection } from '../../components/common/RelocationSection/RelocationSection';
import LocationView from '../../components/common/LocationView/LocationView';
import SocialLinks from '../../components/ProfileSearch/ProfileDetails/SocialLinks/SocialLinks';
import SkillBar from '../../components/ProfileSearch/ProfileDetails/SkillBar/SkillBar';
import { BadgeRenderer } from '../../components/ProfileSearch/Badges/BadgeRenderer';
import ProfileDetailsOptions from '../../components/ActionDropdowns/ProfileDetailsOptions';

const ProfileOverviewSection = ({ profile, updateHireStatus }) => {

  return (
    <Col sm={3} md={3} xs={12}>
      {/* Contact buttons */}
      <Row className="contact-button__section">
        <ContactButtons
          email={profile.email}
          phoneNumber={profile.phoneNumber}
          candidateId={profile.candidateId}
          optinTextMessages={profile?.optinTextMessages}
        />
      </Row>
      {/* Profile about me */}
      <Row className="p2p-profile__section">
        <div className="p2p-profile__overview p2p-profile__section">
          <div className="p2p-profile__demographic">
            <FavoriteIcon candidate={profile} />
            <ProfileDetailsOptions profile={profile} updateHireStatus={updateHireStatus} />
            <div>
              <ProfileImage profilePicture={profile.profilePicture} />
            </div>
            <p className="name">
              {profile.name}
            </p>
            {
              profile?.selectedTradeTypes?.length > 0
                && profile.selectedTradeTypes.map((trade, i) => {
                  return (
                    <p key={i} className="trade-type">
                      {`${trade}${i < profile.selectedTradeTypes.length - 1 ? ',' : ''}`}
                    </p>
                  );
                })
            }
            {
              profile?.employmentTypes?.length > 0
              && <p>Seeks {profile.employmentTypes.join(', ') } Work</p>
            }
            <AvailabilityStatus availability={profile.availability} availableFrom={profile.availableFrom} />
            <LocationView zipCode={profile.zipCode} city={profile.city} state={profile.state} />
            <RelocationSection
              readyToRelocate={profile.readyToRelocate}
              commuteDistance={profile.commuteDistance}
            />
            <SocialLinks profile={profile} />
          </div>
          <div className="p2p-profile__experience-lvl">
            <h3>Experience Level</h3>
            <SkillBar yearsOfExperience={profile.yearsOfExperience} />
            {profile.yearsOfExperience}
          </div>
          {profile.aboutMe && (
            <div className="p2p-profile__about-me">
              <h3>About Me</h3>
              <p className="pre-formatted">
                {profile.aboutMe}
              </p>
            </div>
          )}
          <div className="p2p-profile__badge-section">
            <h3>Badges</h3>
            <div className="p2p-profile__badges">
              <BadgeRenderer profileData={profile} />
            </div>
          </div>
        </div>
      </Row>
    </Col>
  );
};

export default ProfileOverviewSection;
ProfileOverviewSection.propTypes = {
  profile: PropTypes.shape({
    phoneNumber: PropTypes.string,
    candidateId: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
    selectedTradeTypes: PropTypes.arrayOf(PropTypes.string),
    zipCode: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    commuteDistance: PropTypes.string,
    readyToRelocate: PropTypes.bool,
    yearsOfExperience: PropTypes.string,
    aboutMe: PropTypes.string,
    optinTextMessages: PropTypes.bool
  }).isRequired,
  updateHireStatus: PropTypes.func.isRequired
};
